import type { TitleAttributeSpec, TitleOptions } from "./types";
import { Node } from "@tiptap/core";

export const Title = Node.create<TitleOptions>({
  name: "title",

  content: "inline*",
  defining: true,
  inline: false,
  movable: false,
  duplicatable: false,

  addAttributes() {
    return {
      banner: {
        default: null,
      },
      icon: {
        default: null,
      },
    } satisfies TitleAttributeSpec;
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      HTMLAttributes,
      0,
    ];
  },
});
